<template>
  <div class="top-bar">
    <div class="top-left d-flex align-items-center">
      <img
        src="@/assets/logo_black.png"
        class="logo d-none d-lg-block"
      >
      <div class="separator d-none d-lg-block" />
      <div class="current-date">
        {{ currentDate }}
      </div>
    </div>

    <div class="top-right d-flex align-items-center justify-content-end">
      <div
        class="data-freshness"
        :class="{ pending }"
        @click="$emit('refresh')"
      >
        <span class="freshness-label d-none d-sm-inline">
          {{ $t('general.dataFreshness') }}
        </span>
        <span
          v-if="freshness < 10"
          class="text-success font-weight-bold"
        >
          <i class="fas fa-circle-check pr-1" />
          {{ freshness < 1 ? '< 1' : Math.round(freshness) }} min
        </span>
        <span
          v-else
          class="text-danger font-weight-bold"
        >
          <i class="fas fa-triangle-exclamation pr-1" />
          {{ freshness < 1 ? '< 1' : Math.round(freshness) }} min
        </span>

        <div class="refresh-icon align-items-center justify-content-center">
          <i class="fas fa-arrow-rotate-right" />
        </div>
      </div>

      <div
        v-if="catalogId"
        class="screen-switch"
      >
        <RouterLink
          :to="handoutRoute"
          class="switch-option"
          :class="{ active: screen === 'handout' }"
          :title="$t('shop.todayOrder.handoutScreen')"
        >
          <i class="fas fa-bowl-chopsticks-noodles" />
        </RouterLink>
        <RouterLink
          :to="kitchenRoute"
          class="switch-option"
          :class="{ active: screen === 'kitchen' }"
          :title="$t('shop.todayOrder.kitchenScreen')"
        >
          <i class="fas fa-hat-chef" />
        </RouterLink>
      </div>

      <button
        v-if="showSettings"
        type="button"
        class="settings-btn"
        :title="$t('menu.settings')"
        @click="$emit('settings')"
      >
        <i class="fas fa-gear" />
      </button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    payeeId: String,
    catalogId: String,
    // Which screen is currently open: 'handout' or 'kitchen'
    screen: {
      type: String,
      default: 'handout',
    },
    now: String,
    freshness: {
      type: [Number, String],
      default: 0,
    },
    pending: Boolean,
    showSettings: Boolean,
  },
  computed: {
    currentDate() {
      return moment(this.now).format('dddd, DD MMM HH:mm');
    },
    handoutRoute() {
      return {
        path: `/payee/${this.payeeId}/order/today`,
        query: { catalogId: this.catalogId },
      };
    },
    kitchenRoute() {
      return `/payee/${this.payeeId}/shop/${this.catalogId}/kitchen`;
    },
  },
};
</script>

<style lang="scss" scoped>
.top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 16px;
}

.logo {
  height: 30px;
}

.separator {
  width: 2px;
  height: 22px;
  margin: 0 12px;
  background-color: #6c6c6c;
}

.current-date {
  color: $light-gray;
  font-weight: 500;
}

.top-right {
  gap: 14px;
}

.settings-btn {
  border: none;
  background: none;
  padding: 0;
  color: #9a9a9a;
  font-size: 24px;
  line-height: 1;

  &:hover {
    color: #6c6c6c;
  }
}

.screen-switch {
  display: flex;
  gap: 4px;
  padding: 4px;
  border-radius: 30px;
  background-color: #fff;

  .switch-option {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    color: #9a9a9a;
    font-size: 18px;
    text-decoration: none;

    &:hover {
      color: #6c6c6c;
    }

    &.active {
      background-color: $blue;
      color: #fff;
    }
  }
}

.data-freshness {
  position: relative;
  cursor: pointer;
  font-size: 13px;
  white-space: nowrap;

  .freshness-label {
    font-weight: 500;
    padding-right: 4px;
  }

  .refresh-icon {
    display: none;
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 1;
    background-color: #eee;
    top: 0;
    left: 0;
    opacity: 0.8;

    i {
      font-size: 20px;
    }
  }

  &.pending {
    .refresh-icon {
      display: flex;
      i {
        animation-name: rotate;
        animation-duration: 1s;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
        animation-fill-mode: forwards;
      }
    }
  }

  &:hover {
    .refresh-icon {
      display: flex;
    }
  }
}

@keyframes rotate {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}

@media screen and (min-width: 992px) {
  .top-bar {
    padding: 20px 20px 16px;
    margin: 0 20px;
    border-bottom: 1px solid #ddd;
  }

  .data-freshness .freshness-label {
    font-weight: 400;
  }
}
</style>
